import { Pagination, PaginationItem, Stack } from '@mui/material';
import { styled } from '@mui/system';
import { useDispatch, useSelector } from 'react-redux';
import { UPDATE_QUERY } from '../../../reducers/commonReducer';

const StyledPagination = styled(Pagination)(({ theme }) => ({
  '& .MuiPagination-ul': {
    display: 'flex',
    gap: '8px',
    backgroundColor: '#f7f8fa',
    padding: '8px 16px',
    borderRadius: '999px',
  },
  '& .MuiPaginationItem-root': {
    borderRadius: '999px',
    fontWeight: 500,
    minWidth: 36,
    height: 36,
  },
  '& .MuiPaginationItem-root.Mui-selected': {
    backgroundColor: '#fff',
    boxShadow: '0px 2px 6px rgba(0, 0, 0, 0.1)',
    color: '#151313',
  },
  '& .MuiPaginationItem-ellipsis': {
    color: '#888',
  },
}));

const CustomPagination = ({ getQualifiedLeads, user }) => {
  const dispatch = useDispatch();
  const { query: { page, column, totalPages, limit } } = useSelector((state) => state.common);

  const handleChange = async (_, value) => {
    dispatch(UPDATE_QUERY({ limit: 20, page: value }));
    await getQualifiedLeads(user?.['companyId']?.['_id'], `sortBy=${column}&page=${value}&limit-${limit}`)
  };

  return (
    <div className='mt3rem'>
      <Stack spacing={2} alignItems="center">
        <StyledPagination
          count={totalPages}
          page={page}
          onChange={handleChange}
          shape="rounded"
          renderItem={(item) => {
            if (item.type === 'previous') {
              return (
                <PaginationItem
                  {...item}
                  sx={{
                    fontWeight: 600,
                    borderRadius: '999px',
                    padding: '6px 20px',
                    backgroundColor: '#fff',
                    color: '#aaa',
                    border: '1px solid #e0e0e0',
                    pointerEvents: item.disabled ? 'none' : 'auto',
                  }}
                  slots={{ previous: () => '‹ Back' }}
                />
              );
            }

            if (item.type === 'next') {
              return (
                <PaginationItem
                  {...item}
                  sx={{
                    fontWeight: 600,
                    borderRadius: '999px',
                    padding: '6px 20px',
                    backgroundColor: '#2979ff',
                    color: '#fff',
                    border: 'none',
                    '&:hover': {
                      backgroundColor: '#1565c0',
                    },
                  }}
                  slots={{ next: () => 'Next ›' }}
                />
              );
            }

            return (
              <PaginationItem
                {...item}
                sx={{
                  '&.Mui-selected': {
                    fontWeight: 'bold',
                  },
                }}
              />
            );
          }}
        />
      </Stack>
    </div>
  );
};

export default CustomPagination;
